(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSFuncionario', SSFuncionario);

    SSFuncionario.$inject = ['$resource', 'DateUtils'];

    function SSFuncionario ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-funcionarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniFunciones = DateUtils.convertDateTimeFromServer(data.iniFunciones);
                        data.finFunciones = DateUtils.convertDateTimeFromServer(data.finFunciones);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
